module.exports = __webpack_public_path__ + "img/image 14.6b9deb87.png";